// @ts-nocheck TODO

import interact from "interactjs";

export interface DragData {
	annotationUuid: string;
	type:           "freeform" | "bookmark" | "highlight" | "image";
	comment?:       string;
	pageTitle?:     string;
	quote?:         string;
	thumbnailSrc?:  string;
}

export const initDrag = (originalElement, data: DragData) => {
	interact(`.annotation-list-item[data-annotation-uuid="${data.annotationUuid}"]`)
		.draggable({
			manualStart: true,
			listeners:   {
				move: (event) => {
					originalElement.x += event.dx;
					originalElement.y += event.dy;
					event.target.style.transform = `translate(${originalElement.x}px, ${originalElement.y}px)`;

					// Fire event on tiptap editor so the drag cursor appears
					const eventX = new DragEvent("dragover", {
						clientX:    event.client.x,
						clientY:    event.client.y,
						view:       window,
						bubbles:    true,
						cancelable: true
					});
					document.querySelector(".ProseMirror")?.dispatchEvent(eventX);
				},
				end: (event) => {
					interact(event.target).unset();
					document.getElementById("drag-annotation")?.remove();
					document.body.classList.remove("is-dragging"); // remove cursor styles
					originalElement.x = 0;
					originalElement.y = 0;

					// Fire event on tiptap editor so the drag cursor disappears
					const eventX = new DragEvent("dragend", {
						clientX:    event.client.x,
						clientY:    event.client.y,
						view:       window,
						bubbles:    true,
						cancelable: true
					});
					document.querySelector(".ProseMirror")?.dispatchEvent(eventX);
				}
			}
		})
		.on("move", (event) => {
			const interaction = event.interaction;

			// if the pointer was moved while being held down
			// and an interaction hasn't started yet
			if (interaction.pointerIsDown && !interaction.interacting()) {
				const dragElem = document.createElement("pn-annotation-drag");
				dragElem.id = "drag-annotation";
				dragElem.style.position = "absolute";
				dragElem.style.top = event.pageY + "px";
				dragElem.style.left = event.pageX + "px";
				dragElem.data = data;

				document.body.appendChild(dragElem);
				document.body.classList.add("is-dragging"); // for drag cursor

				interaction.start({name: "drag"}, event.interactable, dragElem);
			}
		});
};

export const removeDrag = (annotationUuid) => {
	interact(`.annotation-list-item[data-annotation-uuid="${annotationUuid}"]`).unset();
};
